import clsx from 'clsx';

type Props = {
  pattern: Array<'A' | 'B'>;
  parentALabel?: string;
  parentBLabel?: string;
};

export function WeekGrid({
  pattern,
  parentALabel = 'Parent A',
  parentBLabel = 'Parent B',
}: Props) {
  const days = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
  const len = Math.min(pattern.length, 14);
  return (
    <div className='rounded-lg border border-gray-200 bg-white p-4 shadow-sm'>
      <div className='mb-2 flex flex-wrap gap-4 text-xs text-gray-600'>
        <span className='inline-flex items-center gap-1.5'>
          <span className='h-3 w-3 rounded-sm bg-primary' aria-hidden />
          {parentALabel}
        </span>
        <span className='inline-flex items-center gap-1.5'>
          <span className='h-3 w-3 rounded-sm bg-amber-500' aria-hidden />
          {parentBLabel}
        </span>
      </div>
      <div className='grid grid-cols-7 gap-1 text-center text-xs font-medium text-gray-500'>
        {days.map((d, i) => (
          <div key={`h-${i}`}>{d}</div>
        ))}
      </div>
      <div className='mt-1 grid grid-cols-7 gap-1'>
        {pattern.slice(0, len).map((cell, i) => (
          <div
            key={i}
            className={clsx(
              'aspect-square rounded-md border border-gray-100 text-[10px] font-semibold leading-tight flex items-center justify-center',
              cell === 'A' ? 'bg-primary/85 text-white' : 'bg-amber-400/90 text-gray-900',
            )}
            title={cell === 'A' ? parentALabel : parentBLabel}
          >
            {cell}
          </div>
        ))}
      </div>
      <p className='mt-2 text-xs text-gray-500'>
        Illustrative two-week grid. Your final order may use different labels and transition times.
      </p>
    </div>
  );
}
